import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { DefaultError } from 'src/app/shared/constants/errors.constants';

import { Notification, NOTIFICATION_TYPES, NotificationConfig } from 'src/app/shared/models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public notifications: Array<Notification> = [];
  public $notifications = new Subject();

  private defaultErrorConfig: NotificationConfig = {
    duration: 10000,
    action: null,
    title: null
  };

  pushNotification(
    errorKey: string,
    type: NOTIFICATION_TYPES = NOTIFICATION_TYPES.ERROR,
    options?: NotificationConfig
  ): Notification {
    const config: NotificationConfig = options ? { ...this.defaultErrorConfig, ...options } : this.defaultErrorConfig;

    const notification: Notification = {
      message: errorKey || DefaultError,
      type,
      config,
      id: new Date()
    };
    this.notifications = [ notification, ...this.notifications ];
    this.$notifications.next(this.notifications);

    if (config.duration) {
      setTimeout(() => {
        this.dismissNotification(notification.id);
      }, config.duration);
    }

    return notification;
  }

  dismissNotification(id: Date): void {
    this.notifications = this.notifications.filter((error: Notification) => error.id !== id);
    this.$notifications.next(this.notifications);
  }
}
